import InstagramCRUDActions from '../actions/InstagramCRUDActions';
import Actions from '../actions/actions';
import { setBusy, setUnBusy } from './common/commonReducers';
import { InstagramState } from '../interfaces/instagram';

const initialState: InstagramState = {
  busy: false,
  instagramAccounts: [],
  instagramListMedia: [],
  instagramListMediaPaging: {},
  instagramMedia: [],
};

export const instagram = (
  state: InstagramState = initialState,
  action,
): InstagramState => {
  switch (action.type) {
    case InstagramCRUDActions.busyAction:
      return setBusy(state);
    case InstagramCRUDActions.unbusyAction:
      return setUnBusy(state);

    case InstagramCRUDActions.getIGAccountsAction: {
      const { instagramAccounts } = action;
      return {
        ...state,
        instagramAccounts,
      };
    }
    case InstagramCRUDActions.getIGListMediaAction: {
      const { instagramListMedia, instagramListMediaPaging } = action;
      return {
        ...state,
        instagramListMedia,
        instagramListMediaPaging,
      };
    }
    case InstagramCRUDActions.getIGMediaAction: {
      const { instagramMedia } = action;

      return {
        ...state,
        instagramMedia: [...state.instagramMedia, instagramMedia],
      };
    }
    case Actions.RESET:
      return initialState;
    default:
      return state;
  }
};
